/**
 * テスト心理士のIDリスト
 * 本番環境での表示から除外される心理士のID
 */
export const TEST_COUNSELOR_IDS = [107];
